

// function to sort eleves by id (new eleves, id<0, at the end)
export default function elevesSorter(list) {
    let seniorList = list.filter((senior) => senior.id > 0);
    seniorList.sort((e1, e2) => e1.id > e2.id ? 1 : -1);
    let juniorList = list.filter((junior) => junior.id < 0);
    juniorList.sort((e1, e2) => e1.id > e2.id ? -1 : 1);
    return seniorList.concat(juniorList);
}